export default "/images/vendor/flag-icon-css/flags/1x1/ne.svg?64f5ff142997ea42d42e58f1831693bc";